import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreeningsModuleComponent } from './screenings-list/screenings-module.component';
import { ScreeningComponent } from './screening/screening.component';
import { ScreeningViewComponent } from './screening-view/screening-view.component';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalModule } from '../modal/modal.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from '../pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';
import { ToastrModule } from 'ngx-toastr';
import { ScreeningEditComponent } from './components/screening-edit/screening-edit.component';
import { GuestPaymentModalComponent } from '../shared-components-module/payments/guest-payment-modal/guest-payment-modal.component';
import { IssueTrackerModule } from '../issue-tracker/issue-tracker.module';
import { CreateApplicantInfoComponent } from './components/create-applicant-info/create-applicant-info.component';
import { CreatePkgSelectComponent } from './components/create-pkg-select/create-pkg-select.component';
import { CreateAdditionalDataComponent } from './components/create-additional-data/create-additional-data.component';
import { CreateReviewOrderComponent } from './components/create-review-order/create-review-order.component';
import { CreateOrderSummaryComponent } from './components/create-order-summary/create-order-summary.component';
import { ScreeningsDraftListComponent } from './screenings-draft-list/screenings-draft-list.component';
import { DobDropdownsComponent } from './components/dob-dropdowns/dob-dropdowns.component';
import { ScreeningBatchUploadComponent } from './components/screening-batch-upload/screening-batch-upload.component';
import { ScreeningSearchesTableComponent } from './components/screening-searches-table/screening-searches-table.component';
import { CriminalRecordsManagerComponent } from './components/criminal-records-manager/criminal-records-manager.component';
import { ExcludableRecordsDialogComponent } from './components/excludable-records-dialog/excludable-records-dialog.component';
import { AliasListComponent } from './components/alias-list/alias-list.component';
import { AddressListComponent } from './components/address-list/address-list.component';
import { EvictionRecordsManagerComponent } from './components/eviction-records-manager/eviction-records-manager.component';
import { CustomRecordsManagerComponent } from './components/custom-records-manager/custom-records-manager.component';
import { SsnTraceManagerComponent } from './components/ssn-trace-manager/ssn-trace-manager.component';
import { DecisionGridSettingsReadComponent } from './components/decision-grid-settings-read/decision-grid-settings-read.component';
import { IncomeVerificationManagerComponent } from './components/income-verification-manager/income-verification-manager.component';
import { ApplicantInfoComponent } from './components/applicant-info/applicant-info.component';
import { GridSettingsSummaryComponent } from './components/grid-settings-summary/grid-settings-summary.component';
import { DecisionGridBkSettingsReadComponent } from './components/decision-grid-bk-settings-read/decision-grid-bk-settings-read.component';
import { DecisionGridEvictionSettingsReadComponent } from './components/decision-grid-eviction-settings-read/decision-grid-eviction-settings-read.component';
import { AalManagerComponent } from './components/aal-manager/aal-manager.component';
import { DisputeTrackerModule } from '../dispute-tracker/dispute-tracker.module';
import { ArgyleComponent } from './components/argyle/argyle.component';
import { EmailButtonsPanelComponent } from './components/email-buttons-panel/email-buttons-panel.component';
import { DeepCleaningLogModalComponent } from './components/deep-cleaning-log-modal/deep-cleaning-log-modal.component';
import { IncomeWizardComponent } from './income-wizard/income-wizard.component';
import { WizardReadinessPhaseComponent } from './income-wizard/phases/wizard-readiness-phase.component';
import { WizardStreamPhaseComponent } from './income-wizard/phases/wizard-stream-phase.component';
import { WizardOverviewPhaseComponent } from './income-wizard/phases/wizard-overview-phase.component';
import { StreamReviewQuestionPanelComponent } from './income-wizard/phases/stream-phase/shared/stream-review-question-panel.component';
import { StreamReviewWorknumberComponent } from './income-wizard/phases/stream-phase/stream-types/stream-review-worknumber.component';
import { StreamReviewPayrollComponent } from './income-wizard/phases/stream-phase/stream-types/stream-review-payroll.component';
import { StreamReviewDocuploadComponent } from './income-wizard/phases/stream-phase/stream-types/stream-review-docupload.component';
import { StreamReviewBanksyncComponent } from './income-wizard/phases/stream-phase/stream-types/stream-review-banksync.component';
import { WorkNumberWizardDetailComponent } from './income-wizard/phases/stream-phase/stream-types/work-number-wizard-detail.component';
import { PayrollWizardDetailComponent } from './income-wizard/phases/stream-phase/stream-types/payroll-wizard-detail.component';
import { BanksyncWizardDetailComponent } from './income-wizard/phases/stream-phase/stream-types/banksync-wizard-detail.component';
import { DocuploadWizardDetailComponent } from './income-wizard/phases/stream-phase/stream-types/docupload-wizard-detail.component';



const routes: Routes = [
  {path: 'screenings', component: ScreeningsModuleComponent},
  {path: 'screenings/new', component: ScreeningComponent},
  {path: 'screenings/upload', component: ScreeningBatchUploadComponent},
  {path: 'screenings/review/:scrn', component: ScreeningViewComponent},
  {path: 'processingList/review/:scrn', component: ScreeningViewComponent},
  {path: 'processingList/review/:scrn/:editState', component: ScreeningViewComponent}
 ];

@NgModule({
    declarations: [
        ScreeningsModuleComponent,
        ScreeningComponent,
        ScreeningViewComponent,
        ScreeningEditComponent,
        CreateApplicantInfoComponent,
        CreatePkgSelectComponent,
        CreateAdditionalDataComponent,
        CreateReviewOrderComponent,
        CreateOrderSummaryComponent,
        ScreeningsDraftListComponent,
        DobDropdownsComponent,
        ScreeningBatchUploadComponent,
        ScreeningSearchesTableComponent,
        CriminalRecordsManagerComponent,
        ExcludableRecordsDialogComponent,
        AliasListComponent,
        AddressListComponent,
        EvictionRecordsManagerComponent,
        CustomRecordsManagerComponent,
        SsnTraceManagerComponent,
        DecisionGridSettingsReadComponent,
        IncomeVerificationManagerComponent,
        ApplicantInfoComponent,
        GridSettingsSummaryComponent,
        DecisionGridBkSettingsReadComponent,
        DecisionGridEvictionSettingsReadComponent,
        AalManagerComponent,
        ArgyleComponent,
        EmailButtonsPanelComponent,
        DeepCleaningLogModalComponent,
        IncomeWizardComponent,
        WizardReadinessPhaseComponent,
        WizardStreamPhaseComponent,
        WizardOverviewPhaseComponent,
        StreamReviewQuestionPanelComponent,
        StreamReviewWorknumberComponent,
        StreamReviewPayrollComponent,
        StreamReviewDocuploadComponent,
        StreamReviewBanksyncComponent,
        WorkNumberWizardDetailComponent,
        PayrollWizardDetailComponent,
        BanksyncWizardDetailComponent,
        DocuploadWizardDetailComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbModule,
        NgbdModalModule,
        AngularEditorModule,
        PipesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        DisputeTrackerModule,
        IssueTrackerModule,
        RouterModule.forRoot(routes),
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: false,
        }), // ToastrModule added
    ]
})
export class ScreeningModule { }
